<div class="form-group">
    <mat-form-field appearance="outline" class="full-width">
        <mat-label class="activity-type-setting-label">
            {{'default-activity-settings_activity-type-select-label' | translate}}

            @if (!canModifyActivityType()) {
                <button
                    type="button"
                    [goCdkPopover]="'activity-editor-new_activity-type-cannot-change' | translate"
                    class="ficon-app-help-circle-outline icon-btn"
                    [attr.aria-label]="'activity-editor-new_activity-type-dropdown-help_aria-label' | translate">
                </button>
            }
        </mat-label>

        <mat-select
            data-cy="activity-type-dropdown"
            [formControl]="activityFormService.getControl('activity_template_id')"
            (selectionChange)="onActivityTypeChange($event)">
            <mat-select-trigger>
                @if (templates$ | async; as templates) {
                    @if (activityFormService.getControl('activity_template_id').value; as selectedId) {
                        {{ getTemplateType(templates, selectedId) }}
                    }
                }
            </mat-select-trigger>

            @for (template of templates$ | async; track template.id) {
                <mat-option
                    [value]="template.id"
                    [attr.data-cy]="'activity-type-option-' + template.slug">
                    <strong>{{ template.type }}</strong>
                    <p>{{ template.description }}</p>
                </mat-option>
            }
        </mat-select>
        <mat-icon matIconSuffix class="ficon-app-chevron-down" aria-hidden="true"></mat-icon>
    </mat-form-field>
</div>
